import { Link } from "react-router-dom";
import styles from "./ArtworkCard.module.css";

export default function ArtworkCard({ artwork }) {
  if (!artwork) return null;

  const {
    objectID,
    primaryImageSmall,
    title,
    artistDisplayName,
    objectDate,
  } = artwork;

  const imageSrc =
    primaryImageSmall && primaryImageSmall.trim().length > 0
      ? primaryImageSmall
      : "https://via.placeholder.com/300x300?text=No+Image";

  return (
    <Link to={`/artwork/${objectID}`} className={styles.link}>
      <div className={styles.card}>
        <div className={styles.imageWrapper}>
          <img
            src={imageSrc}
            alt={title || "Artwork"}
            className={styles.image}
            loading="lazy"
          />
        </div>

        <div className={styles.info}>
          <h3 className={styles.title}>{title || "Sem título"}</h3>
          <p className={styles.artist}>
            {artistDisplayName || "Artista desconhecido"}
          </p>
          {objectDate && <p className={styles.date}>{objectDate}</p>}
        </div>
      </div>
    </Link>
  );
}
